<template>
  <hl-Modal dismisable @close="closeModal">
    <h2>Koble faktura</h2>

    <div v-if="originalOrder" class="row mt-5">
      <div class="col">
        <div class="row">
          <div class="col">Fakturadato</div>
          <div class="col"><hl-Date :date="originalOrder.date"></hl-Date></div>
        </div>

        <div class="row">
          <div class="col">Kundenummer</div>
          <div class="col">n/a</div>
        </div>
      </div>

      <div class="col">
        <div class="row">
          <div class="col">Forfallsdato</div>
          <div class="col">n/a</div>
        </div>

        <div class="row">
          <div class="col">Faktura#</div>
          <div class="col">{{ originalOrder.invoiceNumber }}</div>
        </div>
      </div>
    </div>

    <div class="my-4 orderList">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Faktura#</th>
            <th>Forfallsdato</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in filteredOrders" :key="order.id">
            <td>
              <div class="radio">
                <label class="m-0">
                  <input
                    type="radio"
                    v-model="selectedOrder"
                    :value="order.id"
                    :id="order.id"
                    name="optradio"
                    class="mr-3"
                  />
                  {{ order.invoiceNumber }}
                </label>
              </div>
            </td>
            <td>
              <div class="radiotext">
                <label :for="order.id" class="m-0"><hl-Date :date="order.date.due"></hl-Date></label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-5 text-right">
      <button class="btn btn-info mr-2" :disabled="!selectedOrder" @click="postOrderLink">
        Opprett fakturakobling
      </button>
      <button class="btn btn-outline-secondary ml-2" @click="closeModal">Lukk</button>
    </div>
  </hl-Modal>
</template>

<script>
import { mapActions } from 'vuex';
import Modal from '@modules/husleie-framework/src/components/modals/Modal.vue';
import Date from '@modules/husleie-framework/src/components/time/Date.vue';

export default {
  components: {
    'hl-Modal': Modal,
    'hl-Date': Date,
  },

  props: ['landlordId', 'tenancyId', 'sourceOrder'],

  data() {
    return {
      orders: null,
      originalOrder: null,
      selectedOrder: null,
    };
  },

  computed: {
    filteredOrders() {
      if (this.orders == null) return;
      return this.orders.filter(order => order.status.order === 'invoiced');
    },
  },

  methods: {
    ...mapActions('tenancy', ['fetchTenancyAccountingOrders', 'postTenancyAccountingOrdersLink']),
    async fetchOrders() {
      try {
        this.orders = await this.fetchTenancyAccountingOrders({
          landlordId: this.landlordId,
          tenancyId: this.tenancyId,
        });
      } catch (error) {
        console.error(error);
        this.$toast('Kunne ikke hente ordrer.', 'error');
      }
    },

    async postOrderLink() {
      try {
        await this.postTenancyAccountingOrdersLink({
          landlordId: this.landlordId,
          tenancyId: this.tenancyId,
          orderId: this.originalOrder.orderId,
          parentOrderId: this.selectedOrder,
          data: {},
        });
        this.$toast('Fakturaene er nå koblet sammen', 'success');
        this.closeModal();
      } catch (error) {
        console.error(error);
        this.$toast('Kunne ikke lagre lenke.', 'error');
      }
    },

    closeModal() {
      this.$emit('closedConnectPaymentToOtherInvoiceModal');
    },
  },

  mounted() {
    this.originalOrder = this.sourceOrder;
    this.fetchOrders();
  },
};
</script>

<style scoped lang="scss">
.modal-container {
  z-index: 2001;

  .orderList {
    max-height: 400px;
    overflow-y: scroll;
  }
}
</style>
